import { Link, Navigate, Route, Routes, useLocation, useParams } from 'react-router-dom';
import AppShell from '../components/work/AppShell';
import ProjectGeneralSettings from '../components/work/ProjectGeneralSettings';
import ProjectLabelsSettings from '../components/work/ProjectLabelsSettings';
import ProjectMembersSettings from '../components/work/ProjectMembersSettings';
import ProjectStatesSettings from '../components/work/ProjectStatesSettings';
import ProjectSubtypesSettings from '../components/work/ProjectSubtypesSettings';
import { navItemClass } from '../components/work/nav-item';
import { useProjectAdmin } from '../components/work/use-project-admin';

export default function ProjectSettings() {
  const { projectId } = useParams<{ projectId: string }>();
  const location = useLocation();
  if (!projectId) return <div className="p-6 text-sm text-muted-foreground">Missing stream.</div>;
  return <ProjectSettingsShell projectId={projectId} pathname={location.pathname} />;
}

function ProjectSettingsShell({ projectId, pathname }: { projectId: string; pathname: string }) {
  const { isProjectAdmin } = useProjectAdmin(projectId);
  const base = `/projects/${projectId}/settings`;

  return (
    <AppShell projectId={projectId}>
      <div className="flex flex-1 flex-col gap-6 md:flex-row md:gap-8">
        <nav className="flex shrink-0 flex-wrap gap-0.5 md:w-40 md:flex-col" aria-label="Stream settings">
          <Link to={base} className={navItemClass(pathname === base || pathname === `${base}/`)}>
            General
          </Link>
          <Link to={`${base}/states`} className={navItemClass(pathname.startsWith(`${base}/states`))}>
            States
          </Link>
          <Link to={`${base}/labels`} className={navItemClass(pathname.startsWith(`${base}/labels`))}>
            Labels
          </Link>
          <Link to={`${base}/subtypes`} className={navItemClass(pathname.startsWith(`${base}/subtypes`))}>
            Task types
          </Link>
          <Link to={`${base}/members`} className={navItemClass(pathname.startsWith(`${base}/members`))}>
            Members
          </Link>
        </nav>
        <div className="flex min-w-0 flex-1 flex-col">
          <Routes>
            <Route
              index
              element={<ProjectGeneralSettings projectId={projectId} canManage={isProjectAdmin} />}
            />
            <Route
              path="states"
              element={<ProjectStatesSettings projectId={projectId} canManage={isProjectAdmin} />}
            />
            <Route
              path="labels"
              element={<ProjectLabelsSettings projectId={projectId} canManage={isProjectAdmin} />}
            />
            <Route
              path="subtypes"
              element={<ProjectSubtypesSettings projectId={projectId} canManage={isProjectAdmin} />}
            />
            <Route path="members" element={<ProjectMembersSettings projectId={projectId} />} />
            <Route path="*" element={<Navigate to={base} replace />} />
          </Routes>
        </div>
      </div>
    </AppShell>
  );
}
